module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b859e8c3cc92d9c4421e5c8b4aa4fada.png";